import api from './api';

export interface DashboardData {
  totalClientes: number;
  totalApolices: number;
  totalPremio: number;
  apolicesVencidas: number;
  apolicesAVencer: number;
  sinistrosEmAberto: number;
  sinistrosPendentes: number;
  renovacoesPendentes: number;
  vendasMes: number;
  vendasMesAnterior: number;
  crescimentoVendas: number;
  ramosMaisVendidos: {
    nome: string;
    quantidade: number;
  }[];
  sinistrosPorRamo: {
    ramo: string;
    quantidade: number;
  }[];
}

export const dashboardService = {
  getDados: async (): Promise<DashboardData> => {
    const response = await api.get('/dashboard/dados');
    return response.data;
  },

  // Método de teste sem autenticação
  getDadosTeste: async (): Promise<DashboardData> => {
    const response = await api.get('/dashboard/teste');
    return response.data;
  },

  getAniversariantes: async (mes: number): Promise<any[]> => {
    const response = await api.get(`/dashboard/aniversariantes?month=${mes}`);
    return response.data;
  }
}; 